import "./Pricing.module.css";
import Header from "@/reusable_sections/Header";
import IronPeakElevationSeriesPricing from "./sections/IronPeakElevationSeriesPricing";
import TierComparisonTable from "./sections/TierComparisonTable";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <Header />
      <IronPeakElevationSeriesPricing />
      <TierComparisonTable />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}